import React, { useEffect, useState, useRef } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import PaginationTable from '../../pagination/Pagination4';

const Uid_error_data = async () => {
    const response = await fetch(`${process.env.REACT_APP_URL_HEADER}/uidai/uid_error_codes`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    });
    if (!response.ok) {
        throw new Error('Failed to fetch data');
    }
    return response.json();
};

const Uid_error = () => {
    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [tabHeading, setTabHeading] = useState(null);
    
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);
    const [searchQuery, setSearchQuery] = useState(''); // Search query state
    const details2 = useRef(null); // Use ref to scroll to this div

    useEffect(() => {
        const getData = async () => {
            try {
                const response_data = await Uid_error_data();
                setTabHeading(response_data.heading);
                if (response_data.data && response_data.data.length > 0) {
                    setReportData(response_data.data);
                } else {
                    setReportData([]);
                }
            } catch (error) {
                setError(error);
            } finally {
                setLoading(false);
            }
        };

        getData();
    }, []);

    useEffect(() => {
        if (!loading && !error && reportData.length > 0 && details2.current) {
            details2.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }, [loading, error, reportData]);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    
    const handleChangeRowsPerPage = (value) => {
        setRowsPerPage(value === 'all' ? reportData.length : parseInt(value, 10));
        setPage(0);  
    };

    const filteredData = reportData.filter(item =>
        item.error_code.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.error_desc.toLowerCase().includes(searchQuery.toLowerCase())
    );

    // Pagination logic
    const paginatedData = rowsPerPage === 'all' 
        ? filteredData 
        : filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    if (loading) {
        return (
            <div style={{display:'flex', justifyContent:'center', alignItems:'start'}}>
                <br/><br/>
                <Box sx={{ display: 'flex' }}>
                    <CircularProgress /> 
                </Box>
            </div>
        );
    }
    
    if (error) {
        return <div className="mainhead" align="center">Internal Error</div>;
    }
    
    if (reportData.length === 0) {
        return <div className="mainhead" align="center">No data found</div>;
    } 

    return (
        <>
            <br /><br />
            <div width="75%" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '90%' }}>
                <PaginationTable
                    count={filteredData.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </div>
            {/* Search Box */}
            <div style={{ display: 'flex', justifyContent: 'right', alignItems: 'end', marginBottom: '20px',marginRight: '20%' }}>
                <input
                    type="text"
                    placeholder="Search"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    style={{ padding: '8px', width: '300px' }}
                />
            </div>
            <table align="center" width="60%" border={1}>
                <thead>
                    <tr className="tableheader">
                        <th colSpan={17}>{tabHeading}</th>
                    </tr>
                    <tr className="tableheader">
                        <th rowSpan={3}>Sl.No</th>
                        <th rowSpan={3}>Error <br/> Code</th>
                        <th rowSpan={3}>Error <br/> Description</th>
                    </tr>
                </thead>
                <tbody>
                    {paginatedData.map((item, index) => (
                        <tr key={item.error_code}>
                            <td style={{ textAlign: 'center' }}>
                                {rowsPerPage === 'all' ? index + 1 : index + 1 + page * rowsPerPage}
                            </td>
                            <td style={{ textAlign: 'left' }}>{item.error_code}</td>
                            <td style={{ textAlign: 'left' }}>{item.error_desc}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <br /><br />
           <br/><br/>
           
        </>
    );
};

export default Uid_error;
